export default __webpack_public_path__ + "static/toronto-21da1453ced1e287509280a905372e36.svg";